module.exports = __webpack_public_path__ + "static/destination-pin-facee725030e57ae6e24f800e1c188df.png";